export default __webpack_public_path__ + "static/media/apple_watch_1.ae8cfd0a.jpg";